import { PatientFlagDefinition } from "../../../noctem-lib/src/core/contracts/models.calculations";

export const FlagDefinitions =[{
    name: '',
    description: '',
    formula: null
  }
];
